module.exports = __webpack_public_path__ + "/bundle/asset/im-1-89d4040ad04925efc2f49c225dd6444e.png";